import React from 'react'
import PolicyBanner from './PolicyBanner'
import PolicyContent from './PolicyContent'

function PrivicyPolicy() {
  return (
    <div>
      <PolicyBanner/>
      <PolicyContent/>
    </div>
  )
}

export default PrivicyPolicy

